import * as React from 'react';
import type {FieldValues, FormProviderProps} from './types';
import {FormProvider as FormProviderOriginal} from '../../lib/react-hook-form';

export const SailFormContext = React.createContext(false);

export function FormProvider<TFieldValues extends FieldValues = FieldValues>({
  children,
  validate,
  __internal,
  ...props
}: FormProviderProps<TFieldValues>) {
  const formProviderProps = {
    ...props,
    ...__internal,
    trigger: validate,
  };

  return (
    <SailFormContext.Provider value>
      <FormProviderOriginal {...formProviderProps}>
        {children}
      </FormProviderOriginal>
    </SailFormContext.Provider>
  );
}
